<template>
  <div>
    <h2 class="text-center text-danger">
      {{ $t("commons.label.forbidden") }}
    </h2>
    <h6 class="text-center">{{ $t("commons.label.403_title") }}</h6>
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss"></style>
